define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare(Controller, {
		progressTopic: "/csi/table/expand",
		
		process: function() {
			// summary: expand table at specified level or for all levels depending on action
			var view = this.widget;
			var hl = view.getLevelToExpand();
			if (hl != null) {
				this.displayProgressDialog({
					closable: false,
					progressValue: 0
				});

				// prevent flicker - fix scroll node height
				view.freezePopupScrollNode(true);
				view.saveScrollPosition();
				view.expand(hl).then(() => this.postProcess(true));
			} else {
				this.postProcess(true);
			}
		}
	});
});
